import { gql } from '@apollo/client'

export const GET_QUANTITY_OFFERS_RECEIVED = gql`
  query QuantityOffersReceived($filters: EventsFilter) {
    eventOfferIntegrationValidatorAggs(
      size: 0,
      query: {
        bool: {
          filter: [{
            match_phrase: {
              message_keyword: "Ofertas recebidas pelo serviço de validação"
            }
          }]
        }
      },
      aggs: {
        totals: {
          sum: {
            field: "items.totalOffers"
          }
        }
      },
      filters: $filters
    ) {
      aggregations
    }
  }
`

export const GET_QUANTITY_OFFERS_QUEUE = gql`
  query QuantityOffersQueue($filters: EventsFilter) {
    eventOfferIntegrationQueueCount(
      filters: $filters
    )
  }
`

export const GET_DAILY_HTTP_CODES = gql`
  query DailyHttpCodes($filters: JSON) {
    aggregation(
      index: "eventos-offer-integration-*",
      filters: $filters,
      size: 0,
      aggs: {
        httpCodesOverTime: {
          date_histogram: {
            field: "date",
            calendar_interval: "day",
            time_zone: "-03:00"
          },
          aggs: {
            httpCodes: {
              terms: {
                field: "statusCode",
                order: {
                  _count: "desc"
                },
                size: 5
              }
            }
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_PERSISTENT_OFFERS = gql`
  query eventOfferIntegrationDatabaseCount($filters: EventsFilter) {
    eventOfferIntegrationDatabaseCount(
      query: {
        bool: {
          filter: [{
            match_phrase: {
              event_keyword: "INSERT_OFFER_DATABASE"
            }
          }]
        }
      },
      filters: $filters
    )
  }
`

export const GET_QUANTITY_OFFERS_ERROR = gql`
query QuantityOffersReceived($filters: EventsFilter) {
  eventOfferIntegrationValidatorErrorAggs(
    filters: $filters,
    size: 0,
    aggs: {
      totals: {
        sum: {
          field: "items.totalInvalidOffers"
        }
      }
    }
  ) {
    aggregations
  }
}
`

export const GET_SKU_OFFERS_DUPLICATED = gql`
  query eventOfferIntegrationDatabaseCount($filters: EventsFilter) {
    eventOfferIntegrationDatabaseCount(
      query: {
        bool: {
          filter: [{
            match_phrase: {
              event_keyword: "ADD_DUPLICATED_SKU_OFFER"
            }
          }]
        }
      },
      filters: $filters
    )
  }
`
export const GET_QUANTITY_OFFERS_ERRORS_PER_DAY = gql`
  query OffersErrorsPerDay($filters: EventsFilter) {
    eventOfferIntegrationValidatorErrorAggs(
      filters: $filters,
      size: 0,
      aggs: {
        errorsOverTime: {
          date_histogram: {
            field: "date",
            calendar_interval: "day",
            time_zone: "-03:00"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_UNIQUE_REGISTER_OFFERS = gql`
  query QuantityOffersUnique($filters: EventsFilter) {
    eventOfferIntegrationDatabaseCount(
        query: {
          bool: {
            filter: [{
              match_phrase: {
                event_keyword: "ADD_RELEVANT_OFFER"
              }
            }]
          }
        },
        filters: $filters
      )
  }
`

export const GET_EVENT_TYPES = gql`
  query EventOffersIntegrationDatabase($filters: EventsFilter) {
    eventOfferIntegrationDatabaseAggs(
      filters: $filters,
      size: 0,
      aggs: {
        messages: {
          terms: {
            field: "message.keyword",
            order: { _count: "desc" },
            size: 10
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_VALIDATION_ERRORS = gql`
  query ValidationErrors {
    eventOfferIntegrationValidatorErrorAggs(
      size: 0,
      aggs: {
        messages: {
          terms: {
            field: "items.errors.message.keyword",
            size: 10
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_INSERT_OFFERS_QUEUE = gql`
query QuantityOffersQueue($filters: EventsFilter) {
  eventOfferIntegrationQueueAggs(
    filters: $filters,
    size: 0,
    aggs: {
      reasons: {
        date_histogram: {
          field: "date",
          calendar_interval: "day",
            time_zone: "-03:00"
        }
      }
    }
  ) {
    aggregations
  }
}
`

export const GET_TOP_PHARMACIES_OFFERS = gql`
  query ValidationErrors($filters: EventsFilter) {
    eventOfferIntegrationQueueAggs(
      filters: $filters,
      size: 0,
      aggs: {
        pharmacies: {
          terms: {
            field: "items.pharmacyId.keyword",
            order: { _count: "desc" },
            size: 5
          }
        }
      }
    ) {
      aggregations
    }
  }
`

export const GET_QUANTITY_OFFERS_QUEUE_STATE = gql`
query QuantityOffersQueue($filters: JSON) {
  aggregation(
    index: "eventos-offer-integration-*",
    filters: $filters,
    size: 0,
    aggs: {
      data: {
        terms: {
          field: "geoip.region_name.keyword",
          order: {
            _count: "desc"
          },
          size: 27
        }
      }
    }
  ) {
    aggregations
  }
}
`
